import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionMgmtService {
    // Observable sources
    private _sessionTimeoutSource: Subject<boolean>;
    private _logoutPendingSource: Subject<boolean>;
    private _logoutConfirmedSource: Subject<boolean>;
    private _logoutCancelledSource: Subject<boolean>;

    // Observable streams
    sessionTimeout$: Observable<boolean>;
    logoutPending$: Observable<boolean>;
    logoutConfirmed$: Observable<boolean>;
    logoutCancelled$: Observable<boolean>;

    constructor(private _http: HttpClient) {
        this._sessionTimeoutSource = new Subject<boolean>();
        this._logoutPendingSource = new Subject<boolean>();
        this._logoutConfirmedSource = new Subject<boolean>();
        this._logoutCancelledSource = new Subject<boolean>();

        this.sessionTimeout$ = this._sessionTimeoutSource.asObservable();
        this.logoutPending$ = this._logoutPendingSource.asObservable();
        this.logoutConfirmed$ = this._logoutConfirmedSource.asObservable();
        this.logoutCancelled$ = this._logoutCancelledSource.asObservable();
    }

    sessionTimeout(isEventSource: boolean): void {
        this._sessionTimeoutSource.next(isEventSource);
    }

    logoutPending(isEventSource: boolean): void {
        this._logoutPendingSource.next(isEventSource);
    }

    logoutConfirmed(isEventSource: boolean): void {
        this._logoutConfirmedSource.next(isEventSource);
    }

    logoutCancelled(isEventSource: boolean): void {
        this._logoutCancelledSource.next(isEventSource);
    }

    logout(): Observable<any> {
        const apiPath = `/logout`;
        return this._http.get<any>(apiPath);
    }
}
